<template>
    <div class="af-job-alerts">
        <PageHeading>{{ $_seekerFieldByCode('job_alerts').label || $t('job_alert.title') }}</PageHeading>
        <SavedJobAlerts />
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import PageHeading from '@/apps/dashboard/001/components/PageHeading';
    import SavedJobAlerts from '@/apps/dashboard/001/components/SavedJobAlerts/SavedJobAlerts';

    export default {
        name: 'JobAlerts',

        components: {
            PageHeading,
            SavedJobAlerts,
        },

        data() {
            return {};
        },

        computed: {
            ...mapState({
                $_global: state => state.global,
                $_mySavedSearches: state => state.me.savedSearches,
            }),

            ...mapGetters('site', {
                $_seekerFieldByCode: 'seekerFieldByCode',
            }),
        },

        methods: {
            closeModal() {
                this.modal.isOpen = false;
            },

            isSubscriptionActive(subscriptionType) {
                const output = this.frequency.filter(
                    o => o === subscriptionType.frequency,
                );
                return !!output.length;
            },

            updateSubscription(value, subscriptionType) {
                if (value) {
                    this.$store.dispatch('api/me/storeSubscription', {
                        subscription_type_id: subscriptionType.id,
                    });
                } else {
                    this.$store.dispatch(
                        'api/me/deactivateSubscription',
                        subscriptionType.id,
                    );
                }
            },
        },
    };
</script>
